import { useTranslation } from 'next-i18next'
import { PropsWithChildren } from 'react'
import Image from 'next/image'
import Typography from '@Components/typo'
import { Button } from '@Components/button'
import CheckIcon from '../../../../public/images/check-Icon.svg'
import Modal from '..'

interface PhoneNumberModalProps extends PropsWithChildren {
  isOpenModal: boolean
  setIsOpenModal: (isOpen: boolean) => void
  subTitle?: string
  buttonLabel?: string
  handleButton?: () => void
  isLoading?: boolean
  className?: string
}

const SuccessModal = ({
  isOpenModal,
  setIsOpenModal,
  subTitle,
  children,
  handleButton,
  buttonLabel = 'Done',
  isLoading,
  className,
}: PhoneNumberModalProps) => {
  const { t } = useTranslation('common')

  return (
    <Modal
      isOpen={isOpenModal}
      closeModal={() => setIsOpenModal(false)}
      isLoading={isLoading}
      className={className}
    >
      <div className='flex w-full flex-col items-center gap-6'>
        <Image src={CheckIcon} alt='success-icon' />
        <Typography size='h5' weight='bold'>
          {t('successModalTitle')}
        </Typography>
        <Typography size='base'>{subTitle}</Typography>
        {children}
        {handleButton && (
          <Button onClick={handleButton} className='w-full'>
            {buttonLabel}
          </Button>
        )}
      </div>
    </Modal>
  )
}

export default SuccessModal
